/* eslint no-extra-parens: 0 */
import money, { USD } from './money';

export default (currency = USD) => (
  (val) => {
    if (!val) return null;
    if (typeof val === 'number') return money(parseInt(val, 10), currency);

    const onlyNums = val.replace(/[^\d]/g, '');
    return money(parseInt(onlyNums, 10), currency);
  }
);



// WEBPACK FOOTER //
// ./src/lib/currency-serializer.js